import React, { useContext } from "react";
import FilterBox from "../../../Utils/FilterBox/FilterBox"
import CompaniesContext from "../../../../context/companies-context"
import { useTranslation } from "react-i18next";

function Filter(props) {
	
    const { setPageParams } = props

    let companies = useContext(CompaniesContext).onboarding_list

    const { t } = useTranslation();

    let filterTypes = {
        external_id: {
            type: "string",
            disabled: false,
            validation:false,
            description: t("account_id")
        },
        agency_number: {
            type: "string",
            disabled: false,
            validation:false,
            description: t("agency")
        },
        account_number: {
            type: "string",
            disabled: false,
            validation:false,
            description: t("account")
        },
        account_type: {
            type: "enum",
            enumList: [
                ["Pessoa Física", "natural_person"],
                ["Pessoa Jurídica", "legal_person"]
            ],
            disabled: false,
            validation:false,
            description: t("account_type")
        },
        registration_date: {
            type: "date",
            disabled: false,
            validation:false,
            description: t("registration_date")
        }
    }

    if (companies){
        let enumList = companies.companies.sort((a, b) => a.name === b.name ? 0 : a.name > b.name ? 1 : -1).map(company =>{
            return [company.name, company.company_key]
        })
        filterTypes['company_key'] = {
            type: "enum",
            enumList: [
                ["Nenhum", ""],
                ...enumList
            ],  
            disabled: false,
            validation:false,
            description: "Cliente"
        }
    }

    return (
        <FilterBox 
            setPageParams={setPageParams}
            filterTypes={filterTypes}
            local_storage_object_preffix={props.local_storage_object_preffix}
        />
    )

}

export default Filter
